import axios from "axios";
import { Navigate } from "react-router";

// Set up your Axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL, // API base URL
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // This ensures cookies are sent with requests
});

// Add a request interceptor to add Authorization header to every request
api.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("accessToken"); // Get the access token from storage
    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle token expiration
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response &&
      error.response.status === 403 &&
      !originalRequest._retry
    ) {
      // If access token has expired
      originalRequest._retry = true;
      try {
        // Attempt to get a new access token using the refresh token
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/users/refresh-token`,
          {
            withCredentials: true, // Ensure cookies are sent with the request
          }
        );
        const data = response.data.data;

        localStorage.setItem("accessToken", data.access_token);
        localStorage.setItem("refreshToken", data.refresh_token);

        // Update original request's Authorization header with the new access token
        originalRequest.headers[
          "Authorization"
        ] = `Bearer ${response.data.access_token}`;

        // Retry the original request with the new token
        return api(originalRequest);
      } catch (err) {
        console.error("Token refresh failed", err);
        localStorage.removeItem("accessToken");
        localStorage.setremoveItemItem("refreshToken");
        <Navigate to="/login" />;
      }
    }
    return Promise.reject(error);
  }
);

export default api;
